import React from "react";
import { Horizontal } from "./Horizontal";
import { ErrorMessage } from "Inputs/Tools";

export function HorizontalError(props: { children: React.ReactNode }) {
  return !props.children ? (
    <></>
  ) : (
    <Horizontal style={{ marginTop: "-0.75em" }}>
      <ErrorMessage>{props.children}</ErrorMessage>
    </Horizontal>
  );
}
